import useTypedContext from "hooks/useTypedContext";
import { Action } from "types/generated";
import { AccessResult, hasAllRequiredActionsInAnySpace, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

const useCanCreateScan = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = hasAllRequiredActionsInAnySpace([Action.SpaceAdmin], viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateScan;
